import React, { FC, useContext, useEffect, useState } from 'react';
import { SearchContext } from '../../context/search.context';
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster'

import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/images/layers.png'
import './Map.scss';

import { SimpleAdvertEntity } from 'types';
import { SingleAdvert } from './SingleAdvert';
import { LatLngExpression, LeafletMouseEvent } from 'leaflet';
import { CoordinatesContext } from '../../context/coordinate.context';
import env from "react-dotenv";

interface markerPositon {
  latitude: number,
  longitude: number,
}
function LocationMarker() {
  const [position, setPosition] = useState<markerPositon[] | null>(null)

  const map = useMapEvents({
    click(e: LeafletMouseEvent) {
      map.getCenter()
      console.log(e.latlng.lat);
      console.log(e.latlng.lng);
    },

  })
  return (<>
    <h1>Woooe</h1>
  </>);
}


export const Map = () => {
  const { search } = useContext(SearchContext);
  const { coordinates, setCoordinates } = useContext(CoordinatesContext);
  const [adverts, setAdverts] = useState<SimpleAdvertEntity[]>([])
  const position = coordinates.length === 0 ? [52.11, 21.0] : coordinates;



  useEffect(() => {
    (async () => {
      console.log('API URL', env.API_URL)
      const res = await fetch(`https://mapsapi.nextwww.pl/card/search/${search}`);
      const adverts = await res.json();
      setAdverts(adverts.adverts);


    })();
  }, [search])

  useEffect(() => {
    const L = require("leaflet");

    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png")
    });
  }, []);

  return (
    <>
      <div className="map">
        <MapContainer center={position as LatLngExpression} zoom={13} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
                <MarkerClusterGroup
        chunkedLoading
      >
          {adverts.map(ad => (
            <Marker key={ad.id} position={[ad.lat, ad.lon]}>
              <Popup>
                <SingleAdvert id={ad.id} />
              </Popup>
            </Marker>
          ))
          }
          </MarkerClusterGroup>
          <LocationMarker />
        </MapContainer>
      </div>
    </>

  );
}